/**
 * Where a delivery notification opens. Shared by NotificationBell and
 * usePushNotifications so the two agree.
 *
 *   nursery_delivery_run        — you are named driver: the run.
 *   nursery_delivery_failed     — a stop not delivered: the order.
 *   nursery_delivery_exception  — trees refused or damaged: the order.
 */
export function deliveryNotificationPath(type: string | undefined, data?: Record<string, string | number>): string | null {
  if (type === 'nursery_delivery_run' && data?.load_id) return `/nursery/deliveries/${data.load_id}`;
  if ((type === 'nursery_delivery_failed' || type === 'nursery_delivery_exception') && data?.order_id) {
    return `/nursery/orders/${data.order_id}`;
  }
  return null;
}
